import type { Attachment, Message } from './message'
import type { Patient } from './patient'
import type { Person } from './person'
import type { Practitioner } from './practitioner'

export interface NewChat extends Record<string, unknown>{
  id: string
  participants?: ChatParticipant[]
  client?: string | null
  lastMessage?: NewMessage | null
  tags?: ChatMeta['tags']
  messageCount?: number | null
  patient: ChatParticipant
  archived?: boolean | null
  concierge?: boolean | null
  active?: boolean | null
  unread?: boolean | null
  unreadCount?: number | null
}

export interface Chat {
  id: string
  participants?: string[] | null
  meta?: ChatMeta | null
  client_id?: string | null
  last_message?: Message | null
  last_concierge_message?: Message | null
  patient?: Patient | null
  practitioners?: Practitioner[] | null
  participants_offsets?: Record<string, ChatAck> | null
  message_count?: number | null
  is_archived?: boolean | null
  is_concierge?: boolean | null
  is_active?: boolean | null
  is_marked_unread?: boolean | null
  unread_count?: number | null
}

export interface NewMessage {
  id: string
  body?: string | null
  tags?: string[] | null
  author?: string | null
  createdAt?: string | null
  attachment?: Attachment | null
}

export interface ChatParticipant {
  id: string
  type: 'practitioner' | 'patient'
  name: string
  messageOffset?: number | null
  offsetUpdatedAt?: string | null
  visible?: true
}

export interface ChatAck {
  offset: number
  offsetUpdatedAt: string
}

export interface ChatMeta {
  patient?: Patient | null
  patient_id?: string | null
  concierge?: boolean
  tags?: string[] | null
  last_sender?: Person | null
}

export const enum ChatReadStatus {
  Read = 'read',
  Unread = 'unread'
}

export const enum ChatType {
  Own = 'own',
  Current = 'current',
  Concierge = 'concierge',
  Archived = 'archived'
}

export let chatTypeNameMapper: Record<ChatType, string> = {
  [ChatType.Own]: 'My Chats',
  [ChatType.Concierge]: 'Concierge',
  [ChatType.Current]: 'Current',
  [ChatType.Archived]: 'Archived'
}
